import dayjs from "dayjs";

export function getDeadlineDiffDays(endAt) {
  if (!endAt) return null;
  return dayjs(endAt).startOf("day").diff(dayjs().startOf("day"), "day");
}

export function getDeadlineOverlayText(endAt) {
  const diff = getDeadlineDiffDays(endAt);
  if (diff === null) return "";
  if (diff < 0) return "마감";
  if (diff === 0) return "오늘 마감";
  return `D-${diff}`;
}

export function isDeadlineSoon(endAt, withinDays = 7) {
  const diff = getDeadlineDiffDays(endAt);
  if (diff === null) return false;
  return diff >= 0 && diff <= withinDays;
}

export function getDeadlineListSummary(endAt) {
  if (!endAt) return "";
  const diff = getDeadlineDiffDays(endAt);
  if (diff < 0) return "마감";
  if (diff === 0) return "오늘 마감";
  if (diff <= 7) return `D-${diff}`;
  return `${dayjs(endAt).format("MM/DD")} 마감`;
}
